/*
  Single source of truth for the "Submit a Form" hub (/forms).

  Every user-facing submit-form on the site gets ONE entry here — this is
  what keeps the side nav clean: new forms are registered here (and in the
  My Submissions sources, see views/Forms/Hub/MySubmissions.js) instead of
  getting their own nav item. See "Adding a new form" in CLAUDE.md.

  Shape:
    { id, name, path, roles, description, keywords, track?, note? }

  - `roles` must mirror the form's route gate in Routes/RouteHandler.js —
    the hub must never show a card for a page the user can't open.
  - `track` says where submissions land: null means they can't be tracked
    (explain why in `note`), otherwise { label, to } for the tracking page.
  - `keywords` feed the hub's search box — the words people actually type.

  Plain data only (no JSX/MUI imports) so the FAQ, widgets, or tests can
  import it freely; the hub maps `id` to an icon itself.
*/

export const MY_SUBMISSIONS_PATH = "/forms/my-submissions";

export const FORMS_CATALOG = [
  {
    id: "rfq",
    name: "New RFQ",
    path: "/forms/new/rfq",
    roles: ["*"],
    description:
      "Start a quote or order request — window forms, interior and exterior doors, and custom forms. A three-step wizard sets the customer and pricing once, then builds the form.",
    keywords: [
      "rfq",
      "quote",
      "order",
      "window",
      "interior door",
      "exterior door",
      "configurator",
      "bid",
      "pricing",
    ],
    track: { label: "My Submissions", to: MY_SUBMISSIONS_PATH },
  },
  {
    id: "service-request",
    name: "Window Service Request",
    path: "/windowdoor/service-request",
    roles: ["*"],
    description:
      "Send a window or door service issue to the shop — the shop keeps you posted through the request's chat thread.",
    keywords: ["service", "repair", "broken", "warranty", "shop", "window", "door"],
    track: { label: "My Service Requests", to: "/windowdoor/my-service-requests" },
  },
  {
    id: "remodel",
    name: "Remodel Form",
    path: "/forms/remodel",
    roles: ["*"],
    description:
      "Send a remodel lead to the remodel team — windows, entry doors, and patio doors. The lead is emailed with a printable PDF attached, and you get a copy.",
    keywords: ["remodel", "lead", "homeowner", "windows", "patio doors"],
    track: { label: "My Submissions", to: MY_SUBMISSIONS_PATH },
  },
  {
    id: "order-problem",
    name: "Order Problem",
    path: "/forms/order-problem",
    roles: ["*"],
    description:
      "Report something wrong with an order — wrong, missing, or damaged material. Photos help.",
    keywords: ["problem", "issue", "wrong", "missing", "damaged", "report", "complaint"],
    track: null,
    note: "Reports are anonymous, so they don't appear in My Submissions.",
  },
  {
    id: "recognition",
    name: "Caught in the Act",
    path: "/forms/recognition",
    roles: ["*"],
    description:
      "Recognize a coworker for doing something great — pick the person, say what they did, and submit.",
    keywords: ["recognition", "recognize", "shout out", "kudos", "praise", "award"],
    track: { label: "My Submissions", to: MY_SUBMISSIONS_PATH },
  },
  {
    id: "feature-request",
    name: "Request a Feature",
    path: "/forms/feature-request",
    roles: ["*"],
    description:
      "Ask for something Node is missing, or a change to something it already does. Goes straight to the team that builds Node.",
    keywords: ["feature", "suggestion", "idea", "improvement", "change", "wish"],
    track: { label: "My Submissions", to: MY_SUBMISSIONS_PATH },
  },
];
